import { CreateProductContainer } from '@/modules/Products';

const ProductCreate = (): JSX.Element => <CreateProductContainer />;

export default ProductCreate;
